<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("firm.new") }}</span>
      </h2>

      <sweet-input v-model="form.name" :isValid="!$v.form.name.$error" @input="$v.form.name.$touch()" layout="vertical" :label="$t('firm.text')" />
      <sweet-input class="mt-2" v-model="form.vkn" :isValid="!$v.form.vkn.$error" @input="$v.form.vkn.$touch()" layout="vertical" :label="$t('firm.vkn')" />

      <h6 class="mt-2">
        {{ $t("firm.admin.text") }}
        <i 
          v-b-tooltip.hover 
          :title="$t('firm.admin.invite-hint')" 
          class="mdi mdi-help-circle text-muted ml-1" 
          style="cursor: help; font-size: 1.1rem;"
        ></i>
      </h6>
      <organization-member-select :selected="form.admin" :allow-empty="true" @onSelect="onMemberSelect" :organization="currentOrganization" :filterFunction="filterFunction" />
      <small class="text-muted">{{ $t("firm.admin.optional-hint") }}</small>

      <sweet-input
        class="mt-2"
        v-model="form.unitAdminName"
        :isValid="!$v.form.unitAdminName.$error"
        @input="$v.form.unitAdminName.$touch()"
        layout="vertical"
        :label="$t('firm.unit-admin-name')"
      />

      <h6 class="mt-2">{{ $t("firm.application-date") }}</h6>
      <date-picker v-model="form.applicationDate" :first-day-of-week="1" lang="lang" format="DD.MM.YYYY" value-type="timestamp" :placeholder="$t('firm.application-date')" />

      <!-- <div class="d-flex flex-row">
        <div class="mt-2">
          <h6 class="mt-2">{{ $t("firm.status.text") }}</h6>
        </div>
        <div class="pt-3 ml-2"><firm-status-select :selected="form.status" @onSelect="onStatusSelect" /></div>
      </div> -->

      <h6 class="mt-2">{{ $t("firm.context") }}</h6>
      <textarea v-model="form.description" type="text" class="form-control" :placeholder="$t('firm.context')" rows="3"></textarea>

      <b-form-checkbox switch v-model="form.supportService" class="mt-3">
        {{ $t("firm.support-service") }}
      </b-form-checkbox>

      <b-form-checkbox switch v-model="form.virtualServer" class="mt-3">
        {{ $t("firm.virtual-server") }}
      </b-form-checkbox>

      <br />
      <sweet-button @click="save()" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>

  <!-- form input end -->
</template>

<script>
import FirmStatusSelect from "@cc/firm-status-select";
import OrganizationMemberSelect from "@cc/organization-member-select";
import DatePicker from "vue2-datepicker";
import { maxLength, minLength, required } from "vuelidate/lib/validators";

const createDefaultForm = () => ({
  name: undefined,
  vkn: undefined,
  admin: undefined,
  applicationDate: undefined,
  unitAdminName: undefined,
  description: undefined,
  supportService: false,
  virtualServer: false,
});
export default {
  components: { DatePicker, OrganizationMemberSelect, FirmStatusSelect },
  data() {
    return {
      form: createDefaultForm(),
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      vkn: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },

      unitAdminName: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      // applicationDate:{},
      description: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v) {
          this.form = createDefaultForm();
        } else {
          const base = this.prepareFormForEdit(v, ["vkn", "unitAdminName"]);

          this.form = {
            ...createDefaultForm(),
            ...base,
            admin: v?.admin || undefined,
            applicationDate: new Date(v.applicationDate).getTime(),
          };
        }
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`organizationFirm/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`organizationFirm/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`organizationFirm/isEditMode`];
    },
  },
  async mounted() {
    await this.checkOrganizationFirmLimit();
  },
  methods: {
    onStatusSelect(item) {
      this.form = { ...this.form, status: item };
    },
    async checkOrganizationFirmLimit() {
      try {
        if (this.form._id) return;

        const limit = await this.$store.dispatch("organizationFirm/checkOrganizationFirmLimit");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    filterFunction(item) {
      const permissionFilter = new Set(["FIRM_ADMIN"]);

      const hasValidRole = item.accessable && item.roles?.some((role) => role.permissions?.some((permission) => permissionFilter.has(permission)));

      return hasValidRole;
    },
    onMemberSelect(item) {
      this.form = { ...this.form, admin: item };
    },
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        const response = await this.$store.dispatch(`organizationFirm/save`, this.form);
        this.form = createDefaultForm();
        this.$v.$reset();
        this.$toast.success(this.$t("common.success"));
        this.$root.$emit("bv::toggle::collapse", "sidebar-new-firm");
        this.$emit("onSave", response.data);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
